import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { TopBar } from './TopBar'
import { MobileTopBar } from './MobileTopBar'
import { MobileTabBar } from './MobileTabBar'
import { SideMenu } from './SideMenu'
import { BalanceRail } from './BalanceRail'
import { ToastContainer } from '../ToastContainer'

export function Layout() {
  const [showPortfolio, setShowPortfolio] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true)
  const gridCols = showPortfolio
    ? sidebarCollapsed
      ? 'lg:grid-cols-[3.5rem_minmax(0,1fr)_20rem]'
      : 'lg:grid-cols-[12rem_minmax(0,1fr)_20rem]'
    : sidebarCollapsed
      ? 'lg:grid-cols-[3.5rem_minmax(0,1fr)]'
      : 'lg:grid-cols-[12rem_minmax(0,1fr)]'

  useEffect(() => {
    if (!mobileMenuOpen) return
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setMobileMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [mobileMenuOpen])

  return (
    <div
      className={`h-[100dvh] grid grid-cols-1 ${gridCols} grid-rows-[auto_minmax(0,1fr)_auto] lg:grid-rows-[3.5rem_minmax(0,1fr)] bg-zinc-950 text-zinc-100`}
    >
      <MobileTopBar onOpenMenu={() => setMobileMenuOpen(true)} />
      <div className="hidden lg:contents">
        <TopBar
          portfolioOpen={showPortfolio}
          onTogglePortfolio={() => setShowPortfolio((v) => !v)}
          sidebarCollapsed={sidebarCollapsed}
        />
      </div>
      <div className="hidden lg:contents">
        <SideMenu collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed((v) => !v)} />
      </div>
      <main className="row-start-2 col-start-1 lg:col-start-2 overflow-y-auto scrollbar-hide bg-zinc-950">
        {/* Boundary lives inside the layout so lazy route chunks loading on
            first navigation swap only the page area, not the whole shell. */}
        <Suspense
          fallback={<div className="p-6 text-sm text-zinc-500">Loading…</div>}
        >
          <Outlet />
        </Suspense>
      </main>
      {showPortfolio && (
        <div className="hidden lg:contents">
          <BalanceRail />
        </div>
      )}
      <MobileTabBar />
      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-40 flex" role="dialog" aria-modal="true">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setMobileMenuOpen(false)}
            aria-hidden="true"
          />
          <SideMenu
            onNavigate={() => setMobileMenuOpen(false)}
            className="relative w-64 max-w-[80%] h-full border-r border-zinc-800 bg-zinc-950 flex flex-col overflow-y-auto shadow-2xl pt-safe pb-safe"
          />
        </div>
      )}
      <ToastContainer />
    </div>
  )
}
